import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
  templateUrl: './not-found.component.html',
})
export class NotFoundComponent {}
